import { Router } from 'next/router'
import { useEffect, useState } from 'react'

export const useIsInIframe = (defaultState = false) => {
	const [isInIframe, setIsInIframe] = useState(defaultState)
	useEffect(() => {
		setIsInIframe(window !== window.parent)
	}, [])
	return isInIframe
}

export const useIframeRouteSync = (router: Router) => {
	const isInIframe = useIsInIframe()

	// Add router event listener for iframe navigation
	useEffect(() => {
		if (!isInIframe) return

		const handleRouteChange = (url: string) => {
			window.parent.postMessage(
				{
					type: 'routeChangeComplete',
					url: url,
				},
				'*',
			)
		}

		router.events.on('routeChangeComplete', handleRouteChange)
		return () => {
			router.events.off('routeChangeComplete', handleRouteChange)
		}
	}, [router, isInIframe])

	return isInIframe
}

// Hook to get which side (left/right) the iframe is
export function useIframeSide() {
	const [side, setSide] = useState<'left' | 'right' | null>(null)

	useEffect(() => {
		const frameElement = window.frameElement
		if (frameElement) {
			const side = frameElement.getAttribute('data-splitview-side')
			if (side) {
				setSide(side as 'left' | 'right')
			}
		}
	}, [])
	return side
}
